<template>
  <div>
    <form
      class="form"
      method="POST"
      action="javascript:;"
      @submit.prevent="submit"
    >
      <FormError v-if="formError.length > 0" :errorMessages="formError" />

      <FormLoading v-if="!formReady" />

      <CardBase v-else>
        <template #header>{{ $route.meta.title }}</template>
        <template #content>
          <FormRow class="mb-4" :required="true">
            <template #label>Name</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.name.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Name"
                v-model.trim="formData.name"
                v-focus
              />
              <div
                class="form-error"
                v-if="$v.formData.name.$error && formSubmitted"
              >
                <span class="form-error__text" v-if="!$v.formData.name.required"
                  >This field is required.</span
                >
              </div>
            </template>
          </FormRow>

          <FormRow class="mb-4" :required="true">
            <template #label>Level</template>
            <template #field>
              <input
                :class="{
                  'form__input--error':
                    $v.formData.level.$error && formSubmitted,
                }"
                type="text"
                class="form__input"
                placeholder="Level"
                v-model.trim="formData.level"
              />
              <div
                class="form-error"
                v-if="$v.formData.level.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.level.required"
                  >This field is required.</span
                >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.level.numeric"
                  >Only numbers are allowed.</span
                >
              </div>
            </template>
            <template #help>This affects list of users. Lower level means ability to see higher levels. (e.g. Level 3 cannot see Level 0, 1 or 2, but can see 3 and above)</template>
          </FormRow>

          <FormDataLog :data="formData" v-if="!formCreate" />
        </template>

        <template #footer>
          <FormRow class="mb-0">
            <template #field>
              <BaseButton type="submit">Submit</BaseButton>
            </template>
            <template #link>
              <div class="ml-4">
                or
                <router-link :to="{ name: 'USerRoleList' }" class="link ml-2"
                  >Back to List User Roles</router-link
                >
              </div>
            </template>
          </FormRow>
        </template>
      </CardBase>
    </form>
    <Changelog v-if="!this.formCreate" />
  </div>
</template>

<script>
import {
  required, numeric
} from "vuelidate/lib/validators";

import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  mixins: [submitFormMixin],
  computed: {
    assetRequired() {
      return !this.formData.all_asset;
    },
  },
  validations: {
    formData: {
      name: {
        required,
      },
      level: {
        required,
        numeric
      },
    },
  },
  data: () => {
    return {
      formData: {
        level: 1,
      },
    };
  },

  methods: {
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };

            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
  },
};
</script>
